import { Grid } from "@mui/material";
import { useState } from "react";
import Button from "../../../components/Button/Button";
import useStyles from "../styles";
import { Document, Page, pdfjs } from "react-pdf";

// pdfjs.GlobalWorkerOptions.workerSrc =
//   "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.7.570/pdf_viewer.js.map";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

const Resume = () => {
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [pages, setPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    // console.log("object:", numPages, pages);
    setPages(numPages);
    setPageNumber(1);
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Resume’</h4>
            <h6>See the resume of your employee, download at your convenience.</h6>
            <div className={classes.downloadbutton}>
              <Button variant="primary" color="btndefault" buttonSize="full" buttonName="Download Resume" />
            </div>
          </div>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container">
            <Document
              file={{ url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf" }}
              onLoadSuccess={onDocumentLoadSuccess}
              // eslint-disable-next-line no-console
              onLoadError={(error) => console.log("Inside Error", error)}
            >
              <Page pageNumber={pageNumber} style={{ display: "none" }} />
            </Document>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default Resume;
